import { LazyLoadImage as LazyLoadImageComp, LazyLoadImageProps } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const LazyLoadImage = (props: LazyLoadImageProps) => <LazyLoadImageComp {...props} effect="blur" threshold={2000} />;

export default LazyLoadImage;
